module.exports = __webpack_public_path__ + "img/کارت-ویزیت-سلفون-مات-برجسته.3fcbcf7d.png";